(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('MenuConfigController', MenuConfigController);


    MenuConfigController.$inject = [
        'restrictionService', '$scope'
    ];

    function MenuConfigController(restrictionService, $scope) {

        var vm = this;

        vm.showTest = true;

        vm.lectura = restrictionService.lectura; 
    }

    /* INITIALIZER */
    (function () {

    })();

})();